import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const DashboardIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-dashboard${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M6.66667 8.66667C6.66667 9.02029 6.80715 9.35943 7.0572 9.60948C7.30724 9.85953 7.64638 10 8.00001 10C8.35363 10 8.69277 9.85953 8.94281 9.60948C9.19286 9.35943 9.33334 9.02029 9.33334 8.66667C9.33334 8.31305 9.19286 7.97391 8.94281 7.72386C8.69277 7.47381 8.35363 7.33334 8.00001 7.33334C7.64638 7.33334 7.30724 7.47381 7.0572 7.72386C6.80715 7.97391 6.66667 8.31305 6.66667 8.66667Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.96666 7.7L10.3333 6.33334"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.26667 13.3333C3.2921 12.5587 2.58261 11.5001 2.23652 10.3043C1.89043 9.10847 1.92488 7.83459 2.3351 6.65921C2.74531 5.48382 3.51098 4.46514 4.52599 3.74433C5.541 3.02353 6.75509 2.63629 8 2.63629C9.24491 2.63629 10.459 3.02353 11.474 3.74433C12.489 4.46514 13.2547 5.48382 13.6649 6.65921C14.0751 7.83459 14.1096 9.10847 13.7635 10.3043C13.4174 11.5001 12.7079 12.5587 11.7333 13.3333H4.26667Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default DashboardIcon;
